import { useParams } from 'react-router-dom';
import RestaurantTemplate from '../templates/RestaurantTemplate';
import DentistTemplate from '../templates/DentistTemplate';
import RealEstateTemplate from '../templates/RealEstateTemplate';
import LawFirmTemplate from '../templates/LawFirmTemplate';
import FitnessTemplate from '../templates/FitnessTemplate';
import BeautyTemplate from '../templates/BeautyTemplate';
import SaaSTemplate from '../templates/SaaSTemplate';
import EcommerceTemplate from '../templates/EcommerceTemplate';
import PersonalBrandTemplate from '../templates/PersonalBrandTemplate';
import AgencyTemplate from '../templates/AgencyTemplate';
import HotelTemplate from '../templates/HotelTemplate';
import WeddingTemplate from '../templates/WeddingTemplate';
import PhotographerTemplate from '../templates/PhotographerTemplate';
import CryptoTemplate from '../templates/CryptoTemplate';
import CoffeeShopTemplate from '../templates/CoffeeShopTemplate';
import CarDealerTemplate from '../templates/CarDealerTemplate';
import EducationTemplate from '../templates/EducationTemplate';
import ConstructionTemplate from '../templates/ConstructionTemplate';
import YachtTemplate from '../templates/YachtTemplate';
import JetTemplate from '../templates/JetTemplate';
import ArtGalleryTemplate from '../templates/ArtGalleryTemplate';
import PrivateBankTemplate from '../templates/PrivateBankTemplate';
import WatchTemplate from '../templates/WatchTemplate';
import JewelryTemplate from '../templates/JewelryTemplate';
import ArchitectureTemplate from '../templates/ArchitectureTemplate';
import FilmStudioTemplate from '../templates/FilmStudioTemplate';
import SkincareTemplate from '../templates/SkincareTemplate';
import TailorTemplate from '../templates/TailorTemplate';

const previewMap = {
  restaurant: RestaurantTemplate,
  dentist: DentistTemplate,
  realestate: RealEstateTemplate,
  lawfirm: LawFirmTemplate,
  fitness: FitnessTemplate,
  beauty: BeautyTemplate,
  saas: SaaSTemplate,
  ecommerce: EcommerceTemplate,
  personal: PersonalBrandTemplate,
  agency: AgencyTemplate,
  hotel: HotelTemplate,
  wedding: WeddingTemplate,
  photographer: PhotographerTemplate,
  crypto: CryptoTemplate,
  coffee: CoffeeShopTemplate,
  cars: CarDealerTemplate,
  education: EducationTemplate,
  construction: ConstructionTemplate,
  yacht: YachtTemplate,
  jet: JetTemplate,
  artgallery: ArtGalleryTemplate,
  privatebank: PrivateBankTemplate,
  watch: WatchTemplate,
  jewelry: JewelryTemplate,
  architecture: ArchitectureTemplate,
  filmstudio: FilmStudioTemplate,
  skincare: SkincareTemplate,
  tailor: TailorTemplate,
};

export default function TemplatePreview() {
  const { id } = useParams();
  const Template = previewMap[id];

  if (!Template) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
        <p className="text-[#8A857D]">Preview not available yet.</p>
      </div>
    );
  }

  return <Template />;
}
